export const RADIAN = Math.PI / 180;
export const COLORS = ["#1778E1", "#ADCCFF", "#FBBBA0"];
